import { TrackidleService } from './trackidle.service';
import { CasinoPlayerService } from './casino-player.service';
import { BehaviorSubject } from 'rxjs';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Injectable } from '@angular/core';
import { IfStmt } from '@angular/compiler';

@Injectable({
  providedIn: 'root',
})
export class CpinService {
  public tenantId: any;
  public propertyId: any;
  loginPlayerDetails = new BehaviorSubject<any>('default');
  hideDetails = new BehaviorSubject<any>('default');
  loginPlayerCasinoNumber: any = '';
  casinoplayerList: Array<any> = [];
  sessionTimestamp: any;
  userLoggedIn: boolean = false;
  casinoList: Array<any> = [];
  guestDetailsLayout: Array<any> = [];
  reLoginData: any;
  requiredCasinoNumber = new BehaviorSubject('default');
  constructor(
    public AppInitializer: LegacyBookInitService,
    public CasinoPlayerService: CasinoPlayerService,
    public TrackidleService: TrackidleService
  ) {
    this.tenantId = this.AppInitializer.tenantId;
    this.propertyId = this.AppInitializer.propertyId;
    if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-CasinoList')) {
      this.casinoplayerList = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-CasinoList'));
    }
    this.CasinoPlayerService.userData$.subscribe((dat) => {
      if (dat != 'data') {
        this.userLoggedIn = true;
      } else {
        this.userLoggedIn = false;
      }
    });
    if (
      typeof localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'GuestLayout') != 'undefined' &&
      JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'GuestLayout')) != null
    ) {
      this.guestDetailsLayout = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'GuestLayout'));
    }
  }

  casinoTokenValidatios(data) {
    // if (localStorage.getItem(this.tenantId + '-' + this.propertyId + "-CasinoList")) {
    //   let cldata = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + "-CasinoList"));
    //   if (cldata.length != this.casinoplayerList.length) {
    //     this.casinoplayerList = [];
    //   }
    // }
    // else {
    //   this.casinoplayerList = [];
    // }
    this.loginPlayerCasinoNumber = data.casinoNumber;
    this.loginPlayerDetails.next(data);
    // this.casinoplayerList[this.casinoplayerList.length] = data;
    // localStorage.setItem(this.tenantId + '-' + this.propertyId + "-CasinoList", JSON.stringify(this.casinoplayerList));
    // if (!this.userLoggedIn) {
    //   this.TrackidleService.start();
    // }
  }

  validatecasinoNumber(data) {
    // for (let k = 0; k < this.casinoplayerList.length; k++) {
    //   if (this.casinoplayerList[k].casinoNumber == data.casinoNumber && data.sessionts > this.sessionTimestamp) {
    //     this.casinoplayerList[k].count = this.casinoplayerList[k].count + 1;
    //     localStorage.setItem(this.tenantId + '-' + this.propertyId + "-CasinoList", JSON.stringify(this.casinoplayerList));
    //     console.log("Authenticated Casino Player");
    //     return true;
    //   }
    // }
    // return false;
    if (this.casinoList.length > 0) {
      let ind = this.casinoList.indexOf(data.casinoNumber);
      if (ind == -1) {
        if (this.loginPlayerDetails) {
          if (this.loginPlayerCasinoNumber == data.casinoNumber) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      if (this.loginPlayerDetails) {
        if (this.loginPlayerCasinoNumber == data.casinoNumber) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  removeCasinoDetails(data) {
    if (this.casinoplayerList.length > 0) {
      let index = this.casinoplayerList
        .map((e) => {
          return e.casinoNumber;
        })
        .indexOf(data.casinoNumber);
      if (this.casinoplayerList[index].count <= 1) {
        this.casinoplayerList.splice(index, 1);
        localStorage.setItem(this.tenantId + '-' + this.propertyId + '-CasinoList', JSON.stringify(this.casinoplayerList));
      } else {
        this.casinoplayerList[index].count = this.casinoplayerList[index].count - 1;
        localStorage.setItem(this.tenantId + '-' + this.propertyId + '-CasinoList', JSON.stringify(this.casinoplayerList));
      }
    }
  }

  getSessionTimestamp(ts) {
    this.sessionTimestamp = ts;
  }

  setreLoginData(cn, i, j) {
    this.reLoginData = {
      casinoNumber: cn,
      roomIndex: i,
      guestIndex: j,
    };
  }

  getreLoginData() {
    return this.reLoginData;
  }

  updateGuestInfo(data) {
    this.guestDetailsLayout = [];
    this.casinoList = [];
    let casinoPlayerCount = 0;
    for (let g = 0; g < data.length; g++) {
      this.guestDetailsLayout[g] = {
        guestDetails: [],
      };
      for (let h = 0; h < data[g].guestDetails.length; h++) {
        if (data[g].guestDetails[h].isCasinoPlayer) {
          if (data[g].guestDetails[h].Authorized) {
            this.casinoList.push(data[g].guestDetails[h].casinoNo);
            casinoPlayerCount = casinoPlayerCount + 1;
          }

          if (this.guestDetailsLayout.length)
            this.guestDetailsLayout[g].guestDetails[h] = {
              CasinoNumber: data[g].guestDetails[h].casinoNo,
              isCasinoPlayer: true,
              isLoginPlayer: data[g].guestDetails[h].isLoginPlayer,
              isAddedPlayer: data[g].guestDetails[h].isAddedPlayer,
              Authorized: data[g].guestDetails[h].Authorized,
            };
          else {
            let guestDetails = [
              {
                CasinoNumber: data[g].guestDetails[h].casinoNo,
                isCasinoPlayer: true,
                isLoginPlayer: data[g].guestDetails[h].isLoginPlayer,
                isAddedPlayer: data[g].guestDetails[h].isAddedPlayer,
                Authorized: data[g].guestDetails[h].Authorized,
              },
            ];
            this.guestDetailsLayout.push({
              guestDetails: guestDetails,
            });
          }
        } else {
          if (this.guestDetailsLayout.length)
            this.guestDetailsLayout[g].guestDetails[h] = {
              CasinoNumber: '',
              isCasinoPlayer: false,
              isLoginPlayer: false,
              isAddedPlayer: false,
              Authorized: false,
            };
          else {
            let guestDetails = [
              {
                CasinoNumber: '',
                isCasinoPlayer: false,
                isLoginPlayer: false,
                isAddedPlayer: false,
                Authorized: false,
              },
            ];
            this.guestDetailsLayout.push({
              guestDetails: guestDetails,
            });
          }
        }
      }
    }
    if (casinoPlayerCount == 0 && !this.userLoggedIn) {
      this.TrackidleService.stop();
    } else if (casinoPlayerCount > 0 && !this.userLoggedIn) {
      this.TrackidleService.start();
    }
    console.log('Data from book: ', data);
    console.log('Guest Details Layout: ', this.guestDetailsLayout);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-GuestLayout', JSON.stringify(this.guestDetailsLayout));
  }
}
